// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  NewQuoteCompetitor,
  type QuoteCompetitor,
  type QuoteCompetitorWireFormat,
} from '../QuoteCompetitor/QuoteCompetitor';
import {
  NewQuoteStatus,
  QuoteStatus,
  type QuoteStatusWireFormat,
} from '../QuoteStatus/QuoteStatus';

export class UpdateApprovedQuoteRequest {
  readonly version: number | null;
  readonly status: QuoteStatus;
  readonly projectJobNumber: string | null;
  readonly purchaseOrderNumber: string | null;
  readonly competitor: QuoteCompetitor | null;

  constructor(data: { [key: string]: any } = {}) {
    this.version = data.version === undefined ? null : data.version;
    this.status = NewQuoteStatus(data.status);
    this.projectJobNumber = data.projectJobNumber === undefined ? null : data.projectJobNumber;
    this.purchaseOrderNumber =
      data.purchaseOrderNumber === undefined ? null : data.purchaseOrderNumber;
    this.competitor =
      // eslint-disable-next-line no-nested-ternary
      (data.competitor ?? null) === null ? null : NewQuoteCompetitor(data.competitor);
  }

  static zero(): UpdateApprovedQuoteRequest {
    const zeroValues: ExcludeMethodsDeep<UpdateApprovedQuoteRequest> = {
      version: null,
      status: QuoteStatus.zero(),
      projectJobNumber: null,
      purchaseOrderNumber: null,
      competitor: null,
    };
    return new UpdateApprovedQuoteRequest(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UpdateApprovedQuoteRequestWireFormat = {
  version: number | null;
  status: QuoteStatusWireFormat;
  projectJobNumber: string | null;
  purchaseOrderNumber: string | null;
  competitor: QuoteCompetitorWireFormat | null;
};

type NewUpdateApprovedQuoteRequestProps = PartialDeep<
  UpdateApprovedQuoteRequest,
  { recurseIntoArrays: true }
>;
export const NewUpdateApprovedQuoteRequest: (
  props: NewUpdateApprovedQuoteRequestProps,
) => UpdateApprovedQuoteRequest = (props) => new UpdateApprovedQuoteRequest(props);

type NewUpdateApprovedQuoteRequestFromWireFormatProps = PartialDeep<
  UpdateApprovedQuoteRequestWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUpdateApprovedQuoteRequestFromWireFormat: (
  props: NewUpdateApprovedQuoteRequestFromWireFormatProps,
) => UpdateApprovedQuoteRequest = (props) => new UpdateApprovedQuoteRequest(props);
